import * as _actions from './actions';
import _reducer from './reducer';
import _UnlockHomework from './model';

export const UnlockHomework = _UnlockHomework;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/UnlockHomework/index.js